<!--
 * @Description: (弹框)收入设置弹窗
 * @Author: gaohc sunhuihong
 * @Date: 2023-10-17 08:43:52
 * @LastEditTime: 2024-05-28 11:32:24
-->
<template>
  <div class="income-setup-body">
    <el-dialog width="864px" title="参数设置" :visible.sync="visible" :close-on-click-modal="false"
      @open="initData" :before-close="handleCancel" center>
      <div class="header" v-if="instDo && instDo.instParam">
        <div class="header-left">
          <div class="header-text-wrap">
            <img class="vertical-line"
              src="@/assets/common/icon-common-vertical-line.png" alt="">
            <div class="title">
              <span>支付模式</span>
            </div>
          </div>
          <div class="header-group">
            <el-radio-group v-model="instDo.instParam.paymentMode">
              <el-radio :label="1">评估支付</el-radio>
              <el-radio :label="2">立即支付</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="header-right">
          <div class="header-text-wrap">
            <img class="vertical-line"
              src="@/assets/common/icon-common-vertical-line.png" alt="">
            <div class="title">
              <span>权限</span>
            </div>
          </div>
          <div class="header-group">
            <el-checkbox :true-label="1" :false-label="0" v-model="instDo.instParam.enableAtdnDelegateOrder">
              允许护工代客下单
            </el-checkbox>
          </div>
        </div>
      </div>
      <div class="payment-method" :style="{'padding-bottom': paymentPlatform == 1 ? 0 : '100px'}">
        <div class="payment-method-text-wrap">
          <div class="title">
            <div class="header-text-wrap">
              <img class="vertical-line"
              src="@/assets/common/icon-common-vertical-line.png" alt="">
              <span>收款方式</span>
            </div>
            <span class="sub-text">可多选</span>
          </div>
        </div>
        <div class="tabs-wrap" v-if="instDo && instDo.instParam">
          <div class="tab-item" v-for="(item, index) in tabs" :key="index"
            @click="handleSelectTab(item, index)"
            :class="item.select ? 'cancel-item' : ''">
            <span>{{item.name}}</span>
            <span style="font-size: 10px; margin-top: 6px;">
              {{item.tag}}
            </span>
            <img class="select-icon" v-if="item.select"
              src="../../../assets/finance/settlementAcctList/icon-settIement-checked.png" alt="">
          </div>
        </div>
      </div>
      <div class="income-contant" v-if="instDo && instDo.instParam && paymentPlatform == 1"
        v-show="tabs[0].select || tabs[1].select || (tabs[0].select && tabs[1].select) 
          || (!(tabs[0].select) && !(tabs[1].select) && !(tabs[2].select))
          || (tabs[0].select && tabs[1].select) && tabs[2].select">
        <div class="time-set-wrap">
          <div class="section-item-head">
            <img class="vertical-line"
              src="../../../assets/common/icon-common-vertical-line.png" alt="">
            <span style="color: #000; margin-right: 20px">时间设置</span>
            <span>订单完成可立即申请分账，一旦申请分账不支持修改排班和退款</span>
          </div>
          <div style="margin-bottom: 15px; padding-left: 15px;">
            <el-radio v-model="instDo.instParam.revenueSharingType" :label="1"
              @input="instDo.revenueSharingRule = 0">
              逐单分账
            </el-radio>
            <div>
              <el-radio-group v-model="instDo.revenueSharingRule"
                @input="handleIptChange">
                <div style="padding-left: 24px; margin-top: 10px;">
                  <el-radio :label="1">
                    <span>申请后于第</span>
                    <el-input-number v-model="instDo.singleRevenueDays" size="small"
                      style="margin: 0 8px;"
                      :min="0" :max="999" :precision="0">
                    </el-input-number>
                    <span>天6:00自动分账</span>
                  </el-radio>
                </div>
                <div style="padding-left: 24px;padding-top: 15px;">
                  <el-radio :label="2">申请后于6:00自动分账</el-radio>
                </div>
            </el-radio-group>
            </div>
          </div>
          <div style="margin-bottom: 15px; padding-left: 15px;">
            <el-radio v-model="instDo.instParam.revenueSharingType" :label="2"
              @input="instDo.revenueSharingRule = 0">
              批量分账
            </el-radio>
            <div>
              <el-radio-group v-model="instDo.revenueSharingRule" 
                @input="handleIptChange">
                <div style="padding-left: 24px; padding-top: 15px;">
                  <el-radio :label="3">
                    <span>申请后于每月</span>
                    <el-input-number v-model="instDo.batchRevenueDays" size="small"
                      style="margin: 0 8px;"
                      :min="0" :max="28" :precision="0">
                    </el-input-number>
                    <span>日6:00自动分账</span>
                  </el-radio>
                </div>
                <div style="padding-left: 24px;margin-top: 15px;">
                  <el-radio :label="4">申请后于每月最后一天6:00自动分账</el-radio>
                </div>
              </el-radio-group>
            </div>
          </div>
          <div style="margin-bottom: 15px">
            <span>分账完成</span>
            <el-input-number v-model="instDo.instParam.withdrawDays" size="small"
              style="margin: 0 5px" 
              :min="0" :max="999"  label="服务完成" :precision="0">
            </el-input-number>
            <span>天后可提现</span>
          </div>
        </div>
        <div style="height: 1px; background-color: #D7DDE5;margin-bottom: 20px"></div>
        <div class="time-set-wrap">
          <div class="section-item-head">
            <img class="vertical-line"
              src="../../../assets/common/icon-common-vertical-line.png" alt="">
		        <span>分成比例设置</span>
            <el-popover placement="right" title="" width="360" trigger="hover"
              content="设置分成比例后，所有订单均默认按照比例进行分成。">
              <span slot="reference">
                <img style="width: 18px; height: 18px; margin-left: 11px; vertical-align: middle; cursor: pointer;" 
                  src="@/assets/common/icon-common-question-mark.png" alt="">
              </span>
            </el-popover>
		      </div>
          <div v-for="(item, index) in hservicerRatioStrList" :key="index + '-label'">
            <div v-if="item.receiverType == '1' || item.receiverType == '2' || item.receiverType == '3'" class="check-box first">
              <el-checkbox v-model="item.checkedStatus" :disabled="platformDis(item.receiverType)"
                @change="changeSharingType">
                <span :class="platformDis(item.receiverType) ? 'sharing-content-label disable-text' 
                  : 'sharing-content-label'">
                  {{item.receiverTypeText}}:
                </span>
              </el-checkbox>
              <el-input style="width: 160px; margin-left: 8px;"  maxlength="5" size="small" :disabled="platformDis(item.receiverType)" 
                @input="inputSharingRatio(item.ratioStr, index, 'hservicer')" v-model="item.ratioStr">
                <template slot="append">%</template>
              </el-input>
            </div>
          </div>
          <el-checkbox :indeterminate="Isindeterminate" v-model="checkAll" 
            @change="changeAllChecked" style="margin: 17px 0;"
            :disabled="platformDis(999)">
            <span :class="platformDis(999) ? 'sharing-content-label disable-text' 
              : 'sharing-content-label'">个人(派单人、接单人、其他人等)</span>
          </el-checkbox>
          <div class="personal">
            <div v-for="(item, index) in hservicerRatioStrList" :key="item.receiverTypeText + index">
              <div v-if="item.receiverType == '10' || item.receiverType == '11'" 
                class="check-box" style="margin-bottom: 10px;">
                <el-checkbox v-model="item.checkedStatus" @change="changeSharingType"
                  :disabled="platformDis(item.receiverType)">
                  <span :class="platformDis(item.receiverType) ? 'sharing-content-label disable-text' 
                    : 'sharing-content-label'">
                    {{item.receiverTypeText}}:
                  </span>
                </el-checkbox>
                <el-input style="width: 160px; margin-left: 8px;" maxlength="5" size="small"  
                  @input="inputSharingRatio(item.ratioStr, index, 'hservicer')" 
                  v-model="item.ratioStr" :disabled="platformDis(item.receiverType)">
                  <template slot="append">%</template>
                </el-input>
              </div>
            </div>
          </div>
          <div v-for="(item, index) in hservicerRatioStrList" :key="index">
            <div class="personal" v-if="item.receiverType == '20'">
              <div style="display: flex; align-items: center;">
                <el-checkbox v-model="item.checkedStatus" @change="changeSharingType"
                  :disabled="platformDis(item.receiverType)">
                  <span :class="platformDis(item.receiverType) ? 'sharing-content-label disable-text' 
                    : 'sharing-content-label'">{{item.receiverTypeText}}:</span>
                </el-checkbox>
                <el-popover placement="right" title="" width="500" trigger="click">
                  <div class="personal-income-main">
                    <el-input placeholder="请输入姓名/手机号" prefix-icon="el-icon-search" size="mini" v-model="nameOrMobile" 
                      @change="handleAddPerson" />
                    <el-table :data="docnurseList" max-height="200" :header-cell-style="{background:'#EFF5F9'}" 
                      :row-style="tableRowClassName" :cell-class-name="rowClassName" 
                      @row-click="handleClickRow">
                      <el-table-column width="139" prop="name" label="姓名">
                        <template slot-scope="scope">
                          {{scope.row.name}}
                          <span class="error-text">
                            {{scope.row.status == '0' ? '禁用' : ''}}
                          </span>
                        </template>
                      </el-table-column>
                      <el-table-column width="120" prop="mobile" label="联系方式">
                        <template slot-scope="scope">
                          {{scope.row.mobile ? scope.row.mobile : '--'}}
                        </template>
                      </el-table-column>
                      <el-table-column :width="130" prop="privilegeText" label="权限">
                        <template slot-scope="scope">
                          {{scope.row.privilegeText ? scope.row.privilegeText : '--'}}
                        </template>
                      </el-table-column>
                      <el-table-column width="109" label="提现账户">
                        <template slot-scope="scope">
                          {{scope.row.openLklMember ? '已开通' : '未开通'}}
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div slot="reference" @click="handleAddPerson" class="add-share-person-text"
                    v-if="!platformDis(item.receiverType)">
                    <el-image :src="require('@/assets/instmng/instlist/icon-instmng-add-person.png')" fit="cover"
                      style="width: 16px; height: 16px; margin-right: 6px;">
                    </el-image>
                    添加分成人员
                  </div>
                  <div slot="reference" v-else class="add-share-person-text add-share-person-disable-text">
                    添加分成人员
                  </div>
                </el-popover>
              </div>
              <div v-for="(other, index3) in item.otherSharingCfgList" :key="index3" style="margin-top: 20px; display: flex; 
                align-items: center;">
                <div style="display: inline-block; width: 56px; margin-left: 23px; text-align: left;">{{other.attendantName}}：</div>
                <el-input style="width: 160px; margin-left: 8px;"  maxlength="5" size="small"  
                  @input="inputSharingRatio(other.ratioStr, index3, 'other')" v-model="other.ratioStr"
                  :disabled="ortherDis(other.openLklMember)">
                  <template slot="append">%</template>
                </el-input>
                <el-image :src="require('@/assets/instmng/instlist/icon-instmng-delete.png')" fit="cover" 
                  style="width: 16px; height: 16px; margin: 0 20px; cursor: pointer;" @click="handleDelPerson(index3)">
                </el-image>
              </div>
            </div>
          </div>
              
          <div v-show="errorText" class="error-text">{{errorText}}</div>
        </div>
      </div>
      <!-- 线下支付content -->
      <div class="offline-wrap" v-if="instDo && instDo.instParam && paymentPlatform == 1"
        v-show="!(tabs[0].select) && !tabs[1].select && tabs[2].select">
        <img class="offline-image" alt=""
          src="../../../assets/instmng/instlist/icon-instmng-offline-pay.png">
        <div class="offline-pay-text">
          线下付款即需当面向患者进行线下收款（转账、现金等形式）
        </div>
      </div>
      <div  class="dialog-footer bk-wizard-bottons">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleSave">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Constant from '@/global/Constant.js'
import Util from '@/global/Util.js'

export default {
  name: 'IncomeSetup',
  
  props: ["visible", "instId", "instOpenLkl"],

  data() {
    return {
      tabs: [{name: '线上支付', tag: '星护云小程序支付',  type: 1, select: false}, 
             {name: '线上支付', tag: '二维码收款', type: 4, select: false}, 
             {name: '线下支付', tag: '', type: 2, select: false}],
      instDo: {},
      checkedSharingData: [],//选中的比例数据列表
      otherListIndex: 4,  //其他人数组中的下标
      maxScale: 100,//比例最大不能超过100%

      hservicerRatioStrList: [],
      Isindeterminate: false,
      checkAll: false,
      docnurseList: [], //其他人员列表
      nameOrMobile: '', //其他人员列表搜索input

      errorText: '',
      rowClassName: '',

      paymentPlatform: 1   //支付方式  1LKL支付  2微信支付
    }
  },

  computed: {
    platformDis() {
      return (receiverType)=> {
        if (receiverType == 999) return !this.instOpenLkl;
        if (receiverType) {
          return !this.instOpenLkl && (receiverType == '2' || receiverType == '10' 
            || receiverType == '11' || receiverType == '20');
        }
        return false;
      } 
    },

    // 其他人input框禁用
    ortherDis() {
      return (openLklMember)=> {
        return !openLklMember ? true : false;
      } 
    },

    curCheckList() {
      return this.getCheckTypeList(this.hservicerRatioStrList);
    }
  },

  methods: {
    // 1-线上小程序支付 2-线下支付 3-线上小程序支付+线下支付 4-线上二维码支付 
    // 5-线上二维码支付+线下支付 6-线上小程序支付+线上二维码支付 7-线上小程序支付+线上二维码支付+线下支付
    handleSelectTab(item, index) {
      this.$set(this.tabs[index], 'select', !item.select)
      const tabsList = this.tabs.filter(items => {return items.select});
      this.$forceUpdate();
      if (tabsList.length == 2) {
        this.hanldeGetPaymentType(tabsList.map(i => i.type));
      } else if (tabsList.length == 1) {
        this.instDo.instParam.paymentType = tabsList[0].type;
      } else if (tabsList.length == 3) {
        this.instDo.instParam.paymentType = 7;
      } else {
        this.instDo.instParam.paymentType = 0;
      }
    },

    //暂时这么处理 后续会改数据结构在删除
    hanldeGetPaymentType(tabsList) {
      if (Util.compareSameArr(tabsList, [1, 2])) {
        this.instDo.instParam.paymentType = 3;
      } else if (Util.compareSameArr(tabsList, [4, 2])) {
        this.instDo.instParam.paymentType = 5;
      } else if (Util.compareSameArr(tabsList, [1, 4])) {
        this.instDo.instParam.paymentType = 6;
      }
    },

    handleIptChange(val) {
      if (val == 1 || val == 2) {
        this.instDo.instParam.revenueSharingType = 1;
        return
      }
      this.instDo.instParam.revenueSharingType = 2;
    },

    handleSave() {
      // 保存当前状态
      const previousState = {
        hservicerRatioStrList: JSON.parse(JSON.stringify(this.hservicerRatioStrList)),
        instDo: JSON.parse(JSON.stringify(this.instDo)),
        tabs: JSON.parse(JSON.stringify(this.tabs))
      };

      if (!this.instDo.instParam.paymentType) {
        this.$message.warning('请选择收款方式');
        return false;
      }

      let requestParams = {
        instParam: {
          paymentType: this.instDo.instParam.paymentType
        },
        institutionId: this.instId,
        revenueSharingCfgList: []
      };
      if (this.paymentPlatform == 2 || this.instDo.instParam.paymentType == 2) {
        this.handleSendRequest(requestParams, previousState)
        return;
      }
      if (!this.validInstForm()) return
      if (this.validForm(this.hservicerRatioStrList, this.curCheckList)) {
        let tips = this.validForm(this.hservicerRatioStrList, this.curCheckList);  
        this.$message.warning(tips);
        return
      }
      let selectSharingData = this.getCheckedSharingData(this.hservicerRatioStrList, this.curCheckList);
      requestParams.instParam = this.instDo.instParam;
      requestParams.instParam.revenueSharingRule = this.instDo.revenueSharingRule == 1
        || this.instDo.revenueSharingRule == 3 ? 2 : 1;
      requestParams.instParam.revenueDays = this.instDo.revenueSharingRule == 1 ?
      this.instDo.singleRevenueDays : this.instDo.batchRevenueDays;
      selectSharingData = selectSharingData.filter((item) => {
        return delete item.checkedStatus
      });
      requestParams.revenueSharingCfgList = selectSharingData;
      let otherList = this.hservicerRatioStrList[this.otherListIndex].otherSharingCfgList;
      otherList.filter((item) => {
        return delete item.openLklMember
      });
      this.handleSendRequest(requestParams, previousState);
    },

    handleSendRequest(params, previousState) {
      let header = this.encryptionUtil.signatureBody(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'POST',
        url: Constant.URL_SAVE_OR_UPDATE_INCOME_CFG,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_JSON,
      };
      this.vueRequest(requestData).then(result => {
        if (result == null) {
          this.restorePreviousState(previousState);
          return;
        }
        this.clearVaild();
        this.$emit("close-dialog", true);
      })   
    },

    // 新增恢复状态的方法
    restorePreviousState(previousState) {
      if (previousState) {
        this.hservicerRatioStrList = previousState.hservicerRatioStrList;
        this.instDo = previousState.instDo;
        this.tabs = previousState.tabs;
      }
    },
    
    handleCancel() {
      this.clearVaild();
      this.$emit("close-dialog", false);
    },

    handleAddPerson() {
      let paramsData = {nameOrMobile: this.nameOrMobile, instiutionId: this.instId};
      let header = this.encryptionUtil.signatureParams(paramsData,
				Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET', 
        url: Constant.URL_LIST_REVENUE_SHARING_DOCNURSES,
        param: paramsData,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED
      };
      this.vueRequest(requestData).then(result => {
        if (result == null) {
          return;
        }
        this.docnurseList = result.data || [];
      });
    },

    handleClickRow(row, _column, _event) {
      if (row.isOnJob == '0' || row.status == '0') return false;
      if (this.hservicerRatioStrList[this.otherListIndex].otherSharingCfgList.length == 10) return this.$message.error('最多只能添加10个其他分成人员！')
      // 检查复杂对象数组中是否存在相同的对象
      const isDuplicate =  this.hservicerRatioStrList[this.otherListIndex].otherSharingCfgList.some(obj => obj.attendantId === row.id);
      if (!isDuplicate) this.hservicerRatioStrList[this.otherListIndex].otherSharingCfgList.push(
        {attendantId: row.id, attendantName: row.name, openLklMember: row.openLklMember, 'ratioStr': '',
        hserviceId: 0, institutionId: this.instId, receiverType: 20,sharingType: 1, id: 0});
      this.errorText = this.validForm(this.hservicerRatioStrList, this.curCheckList)
    },

    handleDelPerson(index) {
      this.hservicerRatioStrList[this.otherListIndex].otherSharingCfgList.splice(index, 1);
      this.errorText = this.validForm(this.hservicerRatioStrList, this.curCheckList)
    },

    tableRowClassName({row, _index}) {
      let styleRes = {
        "color": "#407EF9 !important"
      }
      if(this.hservicerRatioStrList[this.otherListIndex].otherSharingCfgList.findIndex(item => item.attendantId === row.id) !== -1) {
        return styleRes
      }
    },

    // 获取某页选中的receiverType集合
    getCheckTypeList(list) {
      if (list && list.length) return list.filter(item => item.checkedStatus).map(obj => obj.receiverType) || [];
      return []
    },

    //分账比例改变
    changeSharingType() {
      this.getCheckAllStatus();
      this.checkedSharingData = this.getCheckedSharingData(this.hservicerRatioStrList, this.curCheckList);
      this.errorText = this.validForm(this.hservicerRatioStrList, this.curCheckList);
    },

    // 获取某列表页选中数据
    getCheckedSharingData(list, checkedList) {
      return list.filter(item => checkedList.includes(item.receiverType)) || [];
    },

    //输入比率(例如22.50)整数位不能大于3位,小数点后2位
    inputSharingRatio(value, index, flag) {
      if (flag == 'other') {
        this.changeRatio(value, index, this.hservicerRatioStrList[this.otherListIndex].otherSharingCfgList);
        this.checkedSharingData = this.getCheckedSharingData(this.hservicerRatioStrList[this.otherListIndex].otherSharingCfgList, this.curCheckList);
        this.errorText = this.validForm(this.hservicerRatioStrList, this.curCheckList);
      } else {
        this.changeRatio(value, index, this.hservicerRatioStrList);
        this.checkedSharingData = this.getCheckedSharingData(this.hservicerRatioStrList, this.curCheckList);
        this.errorText = this.validForm(this.hservicerRatioStrList, this.curCheckList);
      }
    },

    // 自动修改比率公用方法
    changeRatio(value, index, list) {
      list[index].ratioStr =  Util.limitInputTwoDecimal(this.commonUtil.filterDigitals(value, ['.']));
      if (list[index].ratioStr.length > 5) {
        list[index].ratioStr = list[index].ratioStr.slice(0, 5);
      }
      if (parseFloat(list[index].ratioStr) > parseFloat(100)) {
        list[index].ratioStr = '100';
      }
    },

    // 全选状态改变
    changeAllChecked() {
      const requiredNumbers = [10, 11, 20] ;
      this.hservicerRatioStrList.map(item => {
        if (requiredNumbers.includes(item.receiverType)) item.checkedStatus = this.checkAll
      })
      
      this.Isindeterminate = false;
      if(this.checkAll) this.errorText = this.validForm(this.hservicerRatioStrList, this.curCheckList)
    },

    // 获取 个人(派单人、接单人、其他人等) 是否全选状态
    getCheckAllStatus() {
      const requiredNumbers = [10, 11, 20];
      const foundNumbers = requiredNumbers.filter(number => this.curCheckList.includes(number))
      this.Isindeterminate = foundNumbers.length > 0 && foundNumbers.length !== requiredNumbers.length;
      this.checkAll = this.curCheckList.includes(10) && this.curCheckList.includes(11) && this.curCheckList.includes(20);
    },

    validPublicFunc(checkedList, checkedSharingData) {
      if (checkedList.length === 0) {
        return '请设置分账比例！';
      }
      const hasEmptyRatio = checkedSharingData.some(item => (item.ratioStr == "" || item.ratioStr == null) && item.receiverType != 20);
      if (hasEmptyRatio) {
        const emptyRatioStr = checkedSharingData.find(element => element.ratioStr == "" || element.ratioStr == null);
        const text = emptyRatioStr.receiverTypeText;
        return `请输入${text}比例`;
      }

      const hasZeroRatio = checkedSharingData.some(item => item.ratioStr == '0');
      if (hasZeroRatio) {
        return '比例必须为正数';
      }

      return ''
    },

    //校验机构设置分成表单
    validInstForm() {
      if (!this.instDo.instParam.revenueSharingType) {
        this.$message.warning('请选择分账方式');
        return false;
      }

      if (this.instDo.instParam.revenueSharingType && !this.instDo.revenueSharingRule) {
        this.$message.warning('请选择自动分账时间');
        return false;
      }

      if (this.instDo.revenueSharingRule == 1 && !this.instDo.singleRevenueDays) {
        this.$message.warning('逐单分账时，输入内容需大于0');
        return false;
      }

      if (this.instDo.revenueSharingRule == 3 && !this.instDo.batchRevenueDays) {
        this.$message.warning('请设置每月多少日自动分账');
        return false;
      }

      return true;
    },

    // 校验方法
    validForm(list, checkedList) {
      const checkedSharingData = this.getCheckedSharingData(list, checkedList);

      const res = this.validPublicFunc(checkedList, checkedSharingData);
      if (res) return res

      if (checkedList.includes(20)) {
        const index = checkedSharingData.findIndex(item => item.receiverType == 20);
        const otherList = checkedSharingData[index].otherSharingCfgList;
        let hasOtherEmptyRatio = false
        let hasOtherZeroRatio = false
        if (!otherList.length) return '请添加其他分成人员';
        hasOtherEmptyRatio = otherList.some(item => {
          return item.openLklMember && !item.ratioStr
        });
        hasOtherZeroRatio = otherList.some(item => {
          return item.openLklMember && Number(item.ratioStr) == 0;
        });
        if (hasOtherEmptyRatio) return '请输入其他人比例';
        
        if (otherList.length === 0 || hasOtherZeroRatio) {
          return '比例必须为正数';
        }
      }

      const scaleSum = this.calculateRatioSum(checkedSharingData);

      if (Number(scaleSum) != Number(this.maxScale)) {
        return '勾选项分成相加之和需等于100';
      }

      return '';
    },

    // 计算选中比例和
    calculateRatioSum(arr) {
      let sum = 0;
      arr.forEach(obj => {
         if (obj.ratioStr) {
          sum += parseFloat(obj["ratioStr"]) || 0;
         }
      });
      let otherObj = this.hservicerRatioStrList[this.otherListIndex]
      let otherList = otherObj.otherSharingCfgList;
      if (otherObj.checkedStatus && otherList && otherList.length) {
        otherList.forEach(item => {
         if (item.ratioStr) {
          sum += parseFloat(item["ratioStr"]) || 0;
         }
      });
      }
      return sum;
    },

    clearVaild() {
      this.instDo = {};
      this.checkedSharingData = [];
      this.nameOrMobile = "";
      this.hservicerRatioStrList = [];
      this.Isindeterminate = false;
      this.checkAll = false;
      this.docnurseList = [];
      this.tabs.forEach(item => {
        this.$set(item, 'select', false);
      });
    },

    initPaymentTabs() {
      if (this.instDo.instParam.paymentType == 7) {
            this.tabs.forEach(item => {
              this.$set(item, 'select', true);
            });
          } else if (this.instDo.instParam.paymentType == 1 || this.instDo.instParam.paymentType == 2
            || this.instDo.instParam.paymentType == 4) {
            const itemIndex = this.tabs.findIndex(item => item.type == this.instDo.instParam.paymentType);
            if (itemIndex != -1) {
              const {...newItem} = this.tabs[itemIndex]; 
              this.tabs[itemIndex] = {...newItem, select: true};
            }
          } else {
            this.initTabsSelect();
          }
    },

    //数据结构的事 暂时判断写死
    initTabsSelect() {
      if (this.instDo.instParam.paymentType == 3) {
        this.tabs[0].select = true;
        this.tabs[2].select = true;
      } else if (this.instDo.instParam.paymentType == 5) {
        this.tabs[1].select = true;
        this.tabs[2].select = true;
      } else if (this.instDo.instParam.paymentType == 6) {
        this.tabs[0].select = true;
        this.tabs[1].select = true;
      }
    },

    initData() {
      let params = {instId: this.instId};
			let header = this.encryptionUtil.signatureParams(params,
				Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET', 
        url: Constant.URL_GET_INCOME_CFG_DO,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED
      };
      this.vueRequest(requestData).then(result => {
        if (result == null) {
          return;
        }
        this.instDo = result.data.instParamDTO;
        this.paymentPlatform = result.data.paymentPlatform;
        this.hservicerRatioStrList = result.data.revenueSharingCfgList;
        this.initPaymentTabs();
        this.hservicerRatioStrList = this.hservicerRatioStrList.map(item => {
          return {
            ...item,
            checkedStatus: item.ratioStr || (item.otherSharingCfgList && item.otherSharingCfgList.length) ?  true : false
          };
        });
        this.getCheckAllStatus();
        this.otherListIndex = this.hservicerRatioStrList.findIndex(item => item.receiverType == 20);
      });
    }
  }
}
</script>

<style scoped>
.header {
  padding: 0 25px;
  display: flex;
  align-items: center;
  margin-bottom: 37px;
}
.header-left {
  width: 60%;
}
.header-right {
  width: 40%;
}
.header-text-wrap {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #000;
  margin: 0 20px 0 0;
}
.header-group {
  width: 100%;
}
.el-radio-group {
  width: 100%;
  margin: 18px 0 0 14px;
}
.header .el-checkbox {
  width: 100%;
  margin: 13px 0 0 14px;
}
.payment-method {
  padding: 0 25px;
}
.payment-method, .tabs-wrap {
  display: flex;
  align-items: center;
}
.payment-method-text-wrap {
  font-size: 14px;
  color: #000;
  margin-right: 20px;
}
.payment-method-text-wrap .title {
  display: flex;
  flex-direction: column;
}
.payment-method-text-wrap .sub-text {
  font-size: 12px; 
  color: #818181;
  margin-left: 14px;
}
.tab-item {
  width: 138px;
  height: 50px;
  text-align: center;
  background: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #D7DDE5;
  color: #606266;
  margin-right: 30px;
  position: relative;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.select-icon {
  width: 22px;
  height: 22px;
  position: absolute;
  right: 0;
  bottom: 0;
}
.cancel-item {
  color: #4784F5;
  border-color: #3E7EF5;
}
.income-contant {
  background: #F7F9FE;
  padding: 30px 0;
  margin: 25px 25px 0 25px;
}
.income-setup-body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.time-set-wrap {
  margin: 0 30px;
  font-size: 14px;
  color: #657180;
}

.dialog-footer {
	text-align: center;
}

.income-setup-body .section-item {
   margin: 5px 0 0 2px;
}

.income-setup-body .section-item-head {
  display: flex;
  align-items: center;
  text-align: left;
  margin-bottom: 25px;
}

.income-setup-body .section-item-head span {
  font-size: 14px;
  color: #657180;
}

.income-setup-body .vertical-line {
  width: 5px;
  height: 20px;
  margin-right: 9px;
}

.income-setup-body .check-box {
  display: flex;
  align-items: center;
}

.income-setup-body .first {
  margin: 10px 0;
}

.income-setup-body .personal {
  padding: 0 30px;
  background-color: #F7F8FA;
}

.income-setup-body .personal .personal-item {
  display: flex;
  align-items: center;
}

.income-setup-body .section-item-form-item {
  margin-left: 34px;
}

.income-setup-body .des-style {
  font-weight: 400;
  font-size: 12px;
  color: #949494;
}

.income-setup-body .el-checkbox {
  display: block;
}

.income-setup-body .el-form-item__content .el-input-group {
  vertical-align: middle !important;
}

.sharing-content-label {
  display: inline-block;
  width: 56px;
  color: #657180
}

.error-text {
  color: #FF3232 !important; 
  font-size: 10px;
}

.disable-text {
  color: #CACED4;
}
.add-share-person-text {
  margin-left: 10px;
  width: 136px; 
  height: 30px; 
  line-height: 30px; 
  border: 1px solid #3E7EF5; 
  border-radius: 4px; 
  font-size: 12px; 
  color: #3E7EF5; 
  display: flex; 
  align-items: center; 
  justify-content: center; 
  cursor: pointer;
}

.add-share-person-disable-text {
  cursor: no-drop;
  color: #CACED4;
  border-color: #CACED4;
}

.offline-wrap {
  margin-top: 90px;
  margin-bottom: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.offline-image {
  width: 145px;
  height: 140px;
}

.offline-pay-text {
  font-size: 14px;
  color: #666666;
  margin-top: 20px;
}
</style>

<style>
.personal-income-main > .el-table {
  margin-top: 10px;
  border: 1px solid #EAEEF5;
}

.personal-income-main > .el-table .el-table__header tr,
.personal-income-main > .el-table  .el-table__header th {
    padding: 0;
    height: 40px;
  }

  .personal-income-main > .el-table .el-table__body tr,
  .personal-income-main > .el-table .el-table__body td {
  padding: 0;
  height: 40px;
}

.personal-income-main > .el-table .disabled-row {
  cursor: not-allowed;
}

.personal-income-main > .el-table .click-row {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/instmng/components/IncomeSetup.vue